import { render, staticRenderFns } from "./UserReviewQueue.vue?vue&type=template&id=42e37cda&scoped=true"
import script from "./UserReviewQueue.vue?vue&type=script&lang=js"
export * from "./UserReviewQueue.vue?vue&type=script&lang=js"
import style0 from "./UserReviewQueue.vue?vue&type=style&index=0&id=42e37cda&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e37cda",
  null
  
)

export default component.exports